module.exports = `
<div>
<div v-if="mode === 'pc'" class="img-switch d-md-inline-block d-none">
	<div>
		<a @click.prevent="switchMode(false)" class="d-inline-block mb-3" href="#">
			<i v-if="largeMode" class="icon-grid1"></i>
			<i v-else class="icon-grid1-2"></i>
		</a>
	</div>
	<div>
		<a @click.prevent="switchMode(true)" class="d-inline-block mb-3" href="#">
			<i v-if="!largeMode" class="icon-grid2"></i>
			<i v-else class="icon-grid2-2"></i>
		</a>
	</div>
</div>


<div v-else class="d-md-none d-block text-center" style="margin-top: 30px; margin-bottom: 30px;">
	<a @click.prevent="switchMode(false)" class="d-inline-block mx-2" href="#">
		<i v-if="largeMode" class="icon-grid2"></i>
		<i v-else class="icon-grid2-2"></i>
	</a>
	<a @click.prevent="switchMode(true)" class="d-inline-block mx-2" href="#">
		<i v-if="!largeMode" class="icon-grid3"></i>
		<i v-else class="icon-grid3-2"></i>
	</a>
</div>

</div>
`;
